import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

export interface ApiError {
	errorCode: string;
	message: string;
}

export interface HttpErrorResponseBody {
	error: string | ApiError;
	errorCode: string;
	message: string | null;
	path: string;
	status: number;
	timestamp: string;
}

@Injectable( {
	providedIn: 'root'
} )
export class ApiErrorsService {

	getMessageKey( error: HttpErrorResponse, translationNodes?: string ): string {
		let result: string = 'tachomat.common.error.something-went-wrong';
		const errorBody: HttpErrorResponseBody = error.error;
		if ( translationNodes ) {
			if ( errorBody && errorBody.errorCode ) {
				result = `${translationNodes}.${errorBody.errorCode}`;
			} else {
				result = `${translationNodes}.${error.status}`;
			}
		}
		return result;
	}

}
